// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"700":"9cc3c2f3","944":"b7e7ccf5"}[chunkId] + ".chunk.css";
};